<template>
  <div>
    <nav>
      <span v-if="authStore.user">
        Connected as {{ authStore.user.sub }} - Role: {{ authStore.user.role }}
      </span>
      <span v-else>Not connected</span>
      <button type="button" v-if="authStore.user" @click="logout">Logout</button>
    </nav>
    <router-view/>
  </div>
</template>

<script setup>
import { useAuthStore } from './stores/auth'
const authStore = useAuthStore()
import { useRouter } from 'vue-router'
const router = useRouter()

const logout = () => {
  authStore.logout()
}

</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 10px;
  background-color: #42b983;
  color: white;
  font-weight: bold;
  text-align: right;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

nav button {
  color: #42b983;
  background-color: white;
  padding: 7px;
}
</style>
